/* Числа месяца, по которым платим. Сетка 1–31: тапом отмечаем нужные.
   Вводить их строкой было бы быстрее для нас и мучительно для человека. */

import React from "react";

import { haptic } from "../lib/tg.js";

const DAYS = Array.from({ length: 31 }, (_, i) => i + 1);

export default function DaysPicker({ caption, days, onChange }) {
  const picked = new Set(days || []);

  const toggle = (d) => () => {
    haptic.select();
    const next = new Set(picked);
    if (next.has(d)) next.delete(d);
    else next.add(d);
    onChange([...next].sort((a, b) => a - b));
  };

  return (
    <div className="mt-8">
      <div className="px-8 pb-1 text-[13px]" style={{ color: "var(--tg-hint)" }}>
        {caption}
      </div>
      <div className="mx-4 rounded-3xl p-2.5" style={{ background: "var(--tg-section-bg)" }}>
        <div className="grid grid-cols-7 gap-1.5">
          {DAYS.map((d) => {
            const on = picked.has(d);
            return (
              <button
                key={d}
                type="button"
                onClick={toggle(d)}
                className="num h-9 rounded-full text-[15px] font-semibold active:opacity-70"
                style={{
                  background: on ? "var(--tg-button)" : "var(--tg-secondary-bg)",
                  color: on ? "var(--tg-button-text)" : "var(--tg-text)",
                }}
              >
                {d}
              </button>
            );
          })}
        </div>
      </div>
      {/* 29–31 есть не в каждом месяце — предупреждаем, а не молча съезжаем */}
      {[...picked].some((d) => d > 28) ? (
        <div className="px-8 pt-1.5 text-[13px]" style={{ color: "var(--tg-hint)" }}>
          В коротких месяцах платёж встанет на последний день.
        </div>
      ) : null}
    </div>
  );
}
